import { FC, useCallback } from "react";
import { StyleSheet, Text, View } from "react-native";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/redux";
import { kFonts } from "src/kFonts";
import { kStyleConst } from "src/kStyle";
import StandardButton from "./StandardButton";

const PaymentTerms: FC = () => {
  const dispatch = useAppDispatch();
  const rVendorId = useSelector(
    (s) => (s.CompanyReducer.type === "brand" || s.CompanyReducer.type === "rep") && s.CompanyReducer.vendorId,
  );
  const rVendorIdAdmin = useSelector(
    (s) =>
      (s.AdminSettingReducer.type === "brand" || s.AdminSettingReducer.type === "rep") &&
      s.AdminSettingReducer.vendorId,
  );

  const showModal = useCallback(() => dispatch({ type: "UPDATE_MODAL_SHOWN", rModalShown: true }), [dispatch]);
  return (
    <View style={styles.gHeaderSpacing}>
      <Text style={styles.gFormHeader}>Payment Terms</Text>
      <Text style={styles.underPaymentTermsSpacing}>
        Upon Order Shipment, we submit payment to you right away, directly to your bank account. Please click below to
        connect your account to receive payments
      </Text>
      {!rVendorId && !rVendorIdAdmin ? (
        <StandardButton style={styles.buttonWidth} type="primary" onPress={showModal} text="SETUP" />
      ) : (
        <View style={styles.rowAlignCenter}>
          <StandardButton type="secondary" onPress={showModal} text="EDIT TERMS" />
          <View style={styles.rowAlignCenterText}>
            <Text>Payment terms completed!</Text>
          </View>
        </View>
      )}
    </View>
  );
};

export default PaymentTerms;

const styles = StyleSheet.create({
  buttonWidth: {
    width: kStyleConst.kNet30SetupWidth,
  },
  gFormHeader: {
    ...kFonts.profileHeader,
    marginBottom: kStyleConst.kSpacing * 2,
  },
  gHeaderSpacing: {
    marginVertical: 15,
  },
  rowAlignCenter: {
    flexDirection: "row",
  },
  rowAlignCenterText: {
    alignSelf: "center",
    marginLeft: 3 * kStyleConst.kSpacing,
  },
  underPaymentTermsSpacing: { marginBottom: 7 * kStyleConst.kSpacing },
});
